/**
 * Newest-messages prefetch: hovering a chat in the list fetches its newest page
 * so opening it is instant (chats.js, 120 ms hover, at most 20 a minute). The
 * chat takes the page once, if it is fresh.
 */

const TTL_MS = 30_000
const WINDOW_MS = 60_000
const MAX_PER_WINDOW = 20

const cache = new Map<string, { at: number; body: Promise<unknown> }>()
let recent: number[] = []

const key = (accountId: string, fanId: string) => `${accountId}:${fanId}`

export function prefetchNewest(accountId: string, fanId: string, fetcher: () => Promise<unknown>, now = Date.now()) {
  const k = key(accountId, fanId)
  const hit = cache.get(k)
  if (hit && now - hit.at < TTL_MS) return
  recent = recent.filter((t) => now - t < WINDOW_MS)
  if (recent.length >= MAX_PER_WINDOW) return
  recent.push(now)
  const body = fetcher().catch(() => {
    cache.delete(k)
    return null
  })
  cache.set(k, { at: now, body })
}

/** The prefetched newest page (once), or null when none is fresh. */
export function takePrefetched(accountId: string, fanId: string, now = Date.now()): Promise<unknown> | null {
  const k = key(accountId, fanId)
  const hit = cache.get(k)
  cache.delete(k)
  return hit && now - hit.at < TTL_MS ? hit.body : null
}

export function clearPrefetch() {
  cache.clear()
  recent = []
}
